import { render, staticRenderFns } from "./edit_treelist.vue?vue&type=template&id=4f0959f6&scoped=true&"
import script from "./edit_treelist.vue?vue&type=script&lang=js&"
export * from "./edit_treelist.vue?vue&type=script&lang=js&"
import style0 from "./edit_treelist.vue?vue&type=style&index=0&id=4f0959f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0959f6",
  null
  
)

export default component.exports